module.exports = __webpack_public_path__ + "img/titleAPc.6c7289a2.png";